module.exports = __webpack_public_path__ + "media/images/Branding/HW Colour Codes _ Font-d470690f7807933b533994246c77c13a.png";